import Modal from '@taglivros/oef_componentes/build/components/modal'
import React from 'react'
import * as S from './styles'

type ModalWantBothProps = {
  handleModal: () => void
  showModal: boolean
}

const ModalWantBoth = ( { handleModal, showModal }: ModalWantBothProps ) => {
  return (
    <S.ModalWrapper>
      <Modal
        altura="auto"
        largura="600px"
        onShowModal={ handleModal }
        show={ showModal }
      >
        <S.Title>
          Combo de assinaturas
        </S.Title>

        <S.Text>
          Para assinar o clube Inéditos e Curadoria basta finalizar a assinatura somente de um dos clubes e após a finalização, realizar a assinatura do segundo clube garantindo um super desconto surpresa! Aproveite!
        </S.Text>

        <S.Button
          onClick={ handleModal }
        >
          Entendi
        </S.Button>
      </Modal>
    </S.ModalWrapper>
  )
}

export default ModalWantBoth
